import type { Schemas } from '#shopware'
import { useShopwareContext } from '#imports'

export const usePagePopups = () => {
    const { apiClient } = useShopwareContext()

    const fetchPopups = async (path: string): Promise<Schemas['Popup'][]> => {
        try {
            const { data } = await apiClient.invoke('readPopups post /popup', {
                body: { path }
            })
            return data ?? []
        } catch (error) {
            console.error('[usePagePopups] Failed to fetch popups', error)
            return []
        }
    }

    return { fetchPopups }
}
